const axiosPromise = import(/* webpackChunkName: "axios" */ 'axios')
import * as types from '../actionTypes'
import UrlUtil from "../../utils/urlUtil"

const url = new UrlUtil('/api/dnd')

export const navigateToSearch = () => {
  return (dispatch) => {
    dispatch({type: types.NAVIGATE_TO_SEARCH})
    window.location.href = '#/'
  }
}

export const navigateToProcessStart = (rowsToShow) => {
  return (dispatch) => {
    dispatch({type: types.NAVIGATE_TO_PROCESS_START, payload: rowsToShow})
    window.location.href = '#/process'
  }
}

export const navigateToPayCharges = (rowsToShow, platform) => {
  return (dispatch) => {
    dispatch({type: types.NAVIGATE_TO_PAYCHARGES, payload: rowsToShow, platform: platform})
    window.location.href = '#/process'
  }
}

export const inquireDnD = (payload) => {
  return async (dispatch) => {
    const axios = (await axiosPromise).default
    const result = await axios.post(url.makeUrl(['whatif']), payload)
    dispatch({type: types.DND_WHAT_IF, payload: result.data})
  }
}

export const confirmPickupDates = (payload) => {
  return async (dispatch) => {
    dispatch({type: types.LOADING_STARTED})
    const axios = (await axiosPromise).default
    const result = await axios.post(url.makeUrl(['confirm']), payload)
    dispatch({type: types.LOADING_STOPPED})
    const resultDataArray = result.data
    if (resultDataArray) {
      const errorMessage = resultDataArray.reduce((result, ea) => result || ea.message, null)
      if (errorMessage) {
        dispatch({type: types.SHOW_ERROR_MESSAGE, payload: errorMessage})
      } else {
        dispatch({type: types.DND_CONFIRM, payload: resultDataArray, confirmInput: payload})
      }
    }
  }
}